import React from "react"

const InfoIcon = ({ size = 17 }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 17 17"
    fill="none"
  >
    <circle
      cx="8.5"
      cy="8.5"
      r="8"
      stroke="black"
      strokeWidth="1"
    />
    <rect
      x="7.5"
      y="4"
      width="2"
      height="2"
      fill="black"
    />
    <rect
      x="7.5"
      y="7"
      width="2"
      height="5"
      fill="black"
    />
  </svg>
)

export default InfoIcon